export default function useCartFormatting() {
    function formatPrice(price, currency) {
        // the theme's price rules (config.json "money"), see basics/money.js
        return Money.format(price, currency);
    }

    function shippingPrices(ctx, prices, number = false, pointType = null, calcWithFreeShipping = true) {
        if(ctx.freeShipping && calcWithFreeShipping) {
            if(number){ return 0; }
            return formatPrice(0, ctx.cartConfig?.currencyCode ?? "HUF");
        }

        if (prices !== null && prices !== undefined && !Array.isArray(prices)) {
            prices = Object.values(prices);
        }

        let min = null;
        let pointMins = {1:null,2:null,3:null};
        let deliveryMethodMin = {};
        if(prices === null || prices === undefined){
            if(number){ return 0; }
            return formatPrice(0, ctx.cartConfig?.currencyCode ?? "HUF");
        }

        let pool = prices;
        const regionPrices = prices.filter((price) => String(price.post_code_regex ?? "").length > 0);
        if (regionPrices.length > 0) {
            const matched = regionPrices.filter((price) => ctx.checkRegionPostCode ? ctx.checkRegionPostCode(price.post_code_regex) : false);
            if (matched.length > 0) {
                pool = matched;
            } else {
                pool = prices.filter((price) => String(price.post_code_regex ?? "").length === 0);
            }
        }
        for (const price of pool) {
            if (price.country_id !== undefined && price.country_id !== null && price.country_id != ctx.countryShipping.id) {
                continue;
            }
            if (Number(price.min_order_amount ?? 0) > ctx.totalPrice) {
                continue;
            }
            if (Number(price.min_order_count ?? 0) > ctx.itemsNum) {
                continue;
            }
            if(deliveryMethodMin[price.delivery_method_id] === undefined || deliveryMethodMin[price.delivery_method_id] > price.price){
               deliveryMethodMin[price.delivery_method_id] = price;
            }
            if (min === null || min.price > price.price) {
                min = price;
                if(price.delivery_point_type === null){
                    pointMins[1] = price;
                    pointMins[2] = price;
                    pointMins[3] = price;
                }
            }
            if(price.delivery_point_type !== undefined && (price.delivery_point_type !== null && (pointMins[price.delivery_point_type] === null || pointMins[price.delivery_point_type].price > price.price))){
                pointMins[price.delivery_point_type] = price;
            }
        }

        if(min === null){
            // no valid price (e.g. none for this post code): no price label
            return number ? 0 : "";
        }

        if (number) {
            if(pointType !== null){
                return Math.max(0,pointMins[pointType]?.price - ctx.extraCredit);
            }
            return Math.max(0,min.price - ctx.extraCredit);
        }

        let differentPrices = false;
        for (const p in pointMins) {
            if(pointMins[p] !== null && pointMins[p].price !== min.price){
                differentPrices = true;
                break;
            }
        }
        if(!differentPrices){
            for (const p in deliveryMethodMin) {
                if(deliveryMethodMin[p] !== null && deliveryMethodMin[p].price !== min.price){
                    differentPrices = true;
                    break;
                }
            }
        }

        const formattedPrice = formatPrice(Math.max(0, min.price - ctx.extraCredit), min?.currency_code);

        if(pointType !== null){
            return formatPrice(Math.max(0,pointMins[pointType]?.price - ctx.extraCredit), min?.currency_code);
        }

        return differentPrices ? lang.basic.from.replace(':price', formattedPrice) : formattedPrice;
    }

    return { formatPrice, shippingPrices };
}
